export const NEWRELIC_APPLICATION_ID='21735165'